import { gql } from "@apollo/client";
export const MasterDataQry = gql`
{
  currencies{
    value
    shorthand
  }  
  countries{
    value
  }
  regions{
    id
    value
  }
}
`;

